import React from "react"

import { Configure, Index } from "react-instantsearch-dom"
import { useIntl } from "react-intl"

import ScrollInfiniteHits from "./Algolia/InfiniteHits/ScrollInfiniteHits"

const GATSBY_ALGOLIA_BASE_FILTER = process.env.GATSBY_ALGOLIA_BASE_FILTER
  ? process.env.GATSBY_ALGOLIA_BASE_FILTER + " AND "
  : ""

function Results(props: any) {
  const intl = useIntl()

  return (
    <Index indexName={props.indexName}>
      <Configure
        filters={GATSBY_ALGOLIA_BASE_FILTER + "language:" + intl.locale}
        hitsPerPage={24}
      />
      <ScrollInfiniteHits
        resultState={props.resultState}
        isFilterDisplayed={props.isFilterDisplayed}
      />
    </Index>
  )
}

export default Results
